import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/services/1.jpg";
import ProjectImg2 from "../../assets/img/services/2.jpg";
import ProjectImg3 from "../../assets/img/services/3.jpg";
import ProjectImg4 from "../../assets/img/services/4-1.jpg";
import house from "../../assets/img/house.jpg";
import students from "../../assets/img/students.jpg";


export default function Services() {
  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{
        marginTop: "30px",
        marginBottom: "80px",

      }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Services</h1>
            <p className="font13">
               These are the services we provide to our clients. We are always open to new ideas and suggestions. If you have any, please feel free to contact us.
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <ProjectBox
                img={ProjectImg2}
                title="Security"
                text="Are you interested in a career in security? Do you have a passion for helping others and a commitment to keeping people safe? If so, we invite you to join our network of security providers."
                action={() => window.location.href = "/security-services-main"}
              />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <ProjectBox
                img={students}
                title="Internships"
                text="Discover the power of transformative internships, where hands-on experience and professional growth intersect to shape a promising future filled with opportunities and success."
                action={() => window.location.href = "/internships"}
              />
            </div>
          </div>
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ProjectBox
                img={house}
                title="Housing Management"
                //if its on mobile put the width to 100
                width={
                  window.innerWidth < 860
                    ? "100%"
                    : "50%"
                }
                text="
                Explore Hatfield and find your ideal home away from home, where comfort and convenience merge to create a welcoming haven for your stay."
                action={() => window.location.href = "/housing-management"}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
